export const VALUE_FIRST_UPGRADE_BOOK_SLOT =
  'https://calendly.com/d/cpst-q4q-7xb/doubletick-number-upgrade?';
